import { render, staticRenderFns } from "./Paymethods.vue?vue&type=template&id=a5e9d2be&"
import script from "./Paymethods.vue?vue&type=script&lang=js&"
export * from "./Paymethods.vue?vue&type=script&lang=js&"
import style0 from "./Paymethods.vue?vue&type=style&index=0&id=a5e9d2be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports